import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { ExoRichTextEditor } from '../../exo/ExoRichTextEditor';
import { RenderHtmlEmail } from '../../email-system/ECEmailConversation';

const TypeRichTextEditor = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors = {},
  onPreventEnter,
  startDataCollection,
  sx,
  size,
}) => {
  const { t } = useTranslation();
  const [html, setHtml] = useState(
    dataCollection && dataCollection[field.key]
      ? dataCollection[field.key]
      : null,
  );

  useEffect(() => {
    if (onPreventEnter) onPreventEnter(true);
    if (startDataCollection && startDataCollection[field.key])
      setHtml(startDataCollection[field.key]);
  }, [startDataCollection]);

  function handleChange(newHtml) {
    if (countVisibleTextCharacters(newHtml) <= 0) {
      updateValidationOnChange(field.key, '');
    } else {
      updateValidationOnChange(field.key, newHtml);
    }
  }
  function countVisibleTextCharacters(htmlString) {
    // Create a temporary div element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Extract the text content
    let textContent = tempDiv.textContent || tempDiv.innerText || '';

    // Remove zero-width and invisible characters (like BOM, ZWSP, etc.)
    textContent = textContent.replace(/[\u200B-\u200D\uFEFF]/g, '');

    // Trim and normalize spaces
    const plainText = textContent.trim().replace(/\s+/g, ' ');

    return plainText.length;
  }

  const hasError = errors[field.key];

  return (
    <ExoRichTextEditor
      startHtml={html}
      onHtmlChange={handleChange}
      hasError={hasError}
      textBlockType={field.textBlockType}
      allowSignature={field.allowSignature}
      autoInsertSignature={field.autoInsertSignature}
      allowBookingLink={field.allowBookingLink}
      allowAiRewrite={field.allowAiRewrite}
      afterHtml={dataCollection[field.afterKey] || ' '}
      afterComponent={
        dataCollection[field.afterKey] && (
          <RenderHtmlEmail
            htmlBody={dataCollection[field.afterKey]}
            inlineAttachments={dataCollection.inlineAttachments}
            editable={Boolean(field.afterEditable)}
            onHtmlChange={(value) =>
              updateValidationOnChange(field.afterKey, value)
            }
          />
        )
      }
      signature={dataCollection[field.signatureKey]}
      onSignatureChange={(value) =>
        updateValidationOnChange(field.signatureKey, value)
      }
      defaultColor={field.color}
      defaultFontSize={field.defaultFontSize}
      bgcolor={field.bgcolor}
      emailCredentials={dataCollection.credentials}
    />
  );
};
export default TypeRichTextEditor;
